// ==============================================
// 人客多 Lakeze 問卷系統 - Mock 資料與設定
// 前端展示階段：所有資料先以 localStorage 模擬，之後接後端
// ==============================================

export const BRAND = {
  orange: "#F97316",
  orangeDark: "#EA580C",
  blue: "#2B8FD9",
  text: "#1A1A1A",
  border: "#E5E5E5",
};

export const LINE_URL = "https://page.line.me/lakeze";
export const LAKEZE_IG = "https://www.instagram.com/lakezetw/";

// 完成並符合資格可獲得的獎勵（首頁與結果頁使用）
export const OFFERS = [
  {
    title: "線上策略諮詢",
    value: "價值 $5,800",
    desc: "完成填寫並通過初步資格，即可預約一對一線上策略諮詢。",
  },
  {
    title: "免費特派員短影音",
    value: "價值 $8,000",
    desc: "有機會獲得人客多特派員到場，為你的場域拍攝專屬短影音。",
  },
];

// 社會證明（歡迎頁 / CTA 附近顯示）
export const SOCIAL_PROOF = "三個月來，已有 3 組場主達到利潤率 4.8 倍以上成長";

// 4 個精選見證場域
export const VENUES = [
  {
    id: "sensan",
    name: "森山寫照",
    tag: "豪華包區露營",
    desc: "被森林環抱的奢華露營，帳篷內設備一應俱全。",
    image: "/venues/sensan.webp",
    ig: "https://www.instagram.com/sensan.inn_/",
  },
  {
    id: "tiansong",
    name: "天送幸福和苑",
    tag: "最多網紅住過的民宿",
    desc: "宜蘭最多網紅造訪的日式風格包棟民宿。",
    image: "/venues/tiansong.png",
    ig: "https://www.instagram.com/lakezetw/",
  },
  {
    id: "hakuna",
    name: "哈庫納馬塔塔",
    tag: "非洲風格泳池包棟",
    desc: "非洲草原風情主題，專屬泳池的度假包棟。",
    image: "/venues/hakuna.png",
    ig: "https://www.instagram.com/hakunamatatayilan/",
  },
  {
    id: "cloudvilla",
    name: "雲岫海景渡假會館",
    tag: "25米戲水池 · 直望龜山島",
    desc: "25 米無邊際戲水池，坐擁龜山島無敵海景。",
    image: "/venues/cloudvilla.webp",
    ig: "https://www.instagram.com/cloudvillatw/",
  },
];

export const STATS = [
  { value: "7-9 成", label: "住房率", sub: "合作後可達成" },
  { value: "4.8 倍", label: "淨利潤提升", sub: "淨利 10萬→48萬" },
  { value: "2280 萬", label: "KOL 累積觀看", sub: "網紅引流曝光" },
];

export const PAIN_POINTS = [
  "廣告和網紅成效不好",
  "訊息回覆不成交",
  "住房率不到 8 成",
  "現場跟行銷、客服無法兼顧",
  "營收不足以請到全職人才",
];

// 痛點 → 人客多的解法（強調人客多特色）
export const PAIN_SOLUTIONS = [
  {
    pain: "廣告和網紅成效不好",
    solve: "潛在客戶引流 ＋ KOL 曝光與合作",
    feature: "每月為你帶來 400–1500 組精準潛在客戶名單",
  },
  {
    pain: "訊息回覆不成交",
    solve: "11 小時待命專業客服",
    feature: "幫你即時回覆、把每一個詢問變成訂單",
  },
  {
    pain: "住房率不到 8 成",
    solve: "Google SEO ＋ 全台唯一自有 PMS 系統",
    feature: "系統化操盤，把住房率穩定拉到 8 成以上",
  },
  {
    pain: "現場跟行銷、客服無法兼顧",
    solve: "行銷 × 客服 × 通路，全代管團隊",
    feature: "你只要專注現場管理，其他交給人客多",
  },
  {
    pain: "營收不足以請到全職人才",
    solve: "一個團隊，抵一整組行銷部門",
    feature: "不用養人，直接把成效外包給人客多",
  },
];

// 人客多如何幫你（品牌定位）
export const VALUE_PROPS = [
  {
    title: "品牌冠名協助",
    desc: "如同 Marriott 的品牌加持，用人客多品牌為你的場域冠名背書，提升信任與能見度。",
  },
  {
    title: "現有客戶導流",
    desc: "把人客多既有的龐大客群直接導流到你的場域，開賣就有客人。",
  },
  {
    title: "重新定位定價",
    desc: "重新定位品牌與定價策略，精準抓對客群，讓每一晚都賣在對的價格。",
  },
  {
    title: "住房率 7-9 成",
    desc: "你只要專注現場管理，潛在客戶引流、KOL 曝光與合作、Google SEO、11 小時待命客服 交給我們，住房率衝上 7-9 成。",
  },
];

// ---------- 問卷選項設定 ----------
const priceOptions = [
  "1200-1400 元",
  "1400-1600 元",
  "1600-1800 元",
  "1800-2000 元",
  "2000-2200 元",
  "2200-2400 元",
  "2400-2600 元",
  "2600-2800 元",
  "2800-3000 元",
  "3000 元以上",
];

export const STEP_META = [
  { num: 1, title: "場域現況" },
  { num: 2, title: "行銷與目標" },
  { num: 3, title: "個人資訊" },
  { num: 4, title: "確認送出" },
];

export const QUESTIONS = {
  step1: [
    {
      key: "location",
      label: "場域地點",
      type: "radio",
      required: true,
      options: ["宜蘭縣", "台中縣", "其他"],
      allowOther: true,
      otherKey: "locationOther",
    },
    {
      key: "roomCount",
      label: "房間數 / 帳篷數",
      type: "radio",
      required: true,
      options: ["1-3 間", "4-5 間", "6 間以上"],
    },
    {
      key: "maxGuests",
      label: "最多可住幾人",
      type: "radio",
      required: true,
      options: ["8-12 人", "12-16 人", "16-20 人", "21 人以上"],
    },
    {
      key: "occupancyRate",
      label: "目前住房率",
      type: "radio",
      required: true,
      options: ["20% 以下", "20-40%", "40-60%", "60-80%", "80% 以上"],
    },
    {
      key: "monthlyRevenue",
      label: "目前月營收",
      type: "radio",
      required: true,
      options: [
        "10 萬以下",
        "10-30 萬",
        "30-60 萬",
        "60-100 萬",
        "100-200 萬",
        "200 萬以上",
      ],
    },
  ],
  step2: [
    {
      key: "runningAds",
      label: "是否有在投廣告？",
      type: "radio",
      required: true,
      options: ["有", "沒有", "曾經投過"],
    },
    {
      key: "kolCooperation",
      label: "是否正與網紅合作？",
      type: "radio",
      required: true,
      options: ["有", "沒有", "曾經合作但效果不好"],
    },
    {
      key: "targetRevenue",
      label: "目標月營收",
      type: "radio",
      required: true,
      options: ["30-60 萬", "60-100 萬", "100-200 萬", "200 萬以上"],
    },
    {
      key: "avgPrice",
      label: "平均單價",
      type: "radio",
      required: true,
      options: priceOptions,
    },
    {
      key: "decisionMaker",
      label: "合作決定權",
      type: "radio",
      required: true,
      options: ["我決定", "合夥人決定", "需要和合夥人討論", "我是主管需與老闆討論"],
    },
  ],
  step3: [
    {
      key: "visitedLakeze",
      label: "是否到過人客多場域？",
      type: "radio",
      required: true,
      options: ["有", "沒有"],
    },
    { key: "name", label: "稱呼", type: "text", required: true, placeholder: "怎麼稱呼您？" },
    { key: "phone", label: "聯絡電話", type: "tel", required: true, placeholder: "09xx-xxx-xxx" },
    {
      key: "lineDisplayName",
      label: "LINE 顯示名稱",
      type: "text",
      required: true,
      placeholder: "您在 LINE 上的顯示名稱",
    },
    {
      key: "lineId",
      label: "LINE ID",
      type: "text",
      required: false,
      placeholder: "選填",
    },
    {
      key: "venueSocial",
      label: "場域 FB / IG 名稱",
      type: "text",
      required: true,
      placeholder: "例如 IG @your_venue 或 FB 粉專名稱",
      hint: "提供場域的 FB 或 IG 名稱，可以讓我們更快了解狀況，更快聯繫您",
    },
  ],
};

export const emptyForm = {
  location: "",
  locationOther: "",
  roomCount: "",
  maxGuests: "",
  occupancyRate: "",
  monthlyRevenue: "",
  runningAds: "",
  kolCooperation: "",
  targetRevenue: "",
  avgPrice: "",
  decisionMaker: "",
  visitedLakeze: "",
  visitedVenues: [],
  name: "",
  phone: "",
  lineDisplayName: "",
  lineId: "",
  venueSocial: "",
  email: "",
  emailConfirm: "",
};

// 到過人客多的哪些場域（可複選）
export const VISITED_VENUE_OPTIONS = [
  "森山寫照｜人客多精選",
  "雲岫海景渡假會館｜人客多精選",
  "哈庫納瑪塔塔｜人客多精選",
  "天送幸福和苑",
];

// ---------- 篩選邏輯 ----------
export function screenSurvey(form) {
  const reasons = [];
  if (form.occupancyRate === "80% 以上") reasons.push("住房率已達 80% 以上");
  if (form.decisionMaker && form.decisionMaker !== "我決定")
    reasons.push("合作決定權非本人");
  if (form.roomCount === "1-3 間") reasons.push("房間數規模過小（1-3 間）");
  if (form.maxGuests === "8-12 人") reasons.push("最多可住人數過少（8-12 人）");
  if (form.targetRevenue === "30-60 萬") reasons.push("目標月營收偏低（30-60 萬）");
  return {
    status: reasons.length > 0 ? "rejected" : "qualified",
    rejectionReasons: reasons,
  };
}

// ---------- 動態提示 ----------
export const HINTS = {
  occupancy:
    "你知道嗎？人客多代管的場域，淡季住房率 70%，旺季可達 90%。你的場域如果住房 / 入住率不到 8 成，等於每個月有 2 成以上的房間或帳篷在空燒，白白損失營收。",
  ads:
    "只靠客人自己上門？人客多透過潛在客戶引流、KOL 曝光與合作、Google SEO，累積 2280 萬觀看。我們旗下有最多網紅造訪的民宿 天送幸福和苑，以及奢華露營區 森山寫照，帶來實際高效的曝光與住房，這些效果你現在都做不到位。",
  kol:
    "人客多旗下有最多網紅造訪的民宿 天送幸福和苑，以及奢華露營區 森山寫照，帶來實際高效的轉單和住房。這些你現在都做不到位，所以合作沒有效果。",
};

// 需要在提示文字中高亮的場域名稱
export const HIGHLIGHT_NAMES = [
  "天送幸福和苑",
  "森山寫照",
  "雲岫海景渡假會館",
  "哈庫納馬塔塔",
];

// ---------- 成長試算（估算值，非實際數字） ----------
const REVENUE_MIDPOINT = {
  "10 萬以下": 10,
  "10-30 萬": 20,
  "30-60 萬": 45,
  "60-100 萬": 80,
  "100-200 萬": 150,
  "200 萬以上": 220,
};

// 合作後營收成長 1.8~2.5 倍；淨利潤以營收平均值的 1/3 估算
export function projectGrowth(monthlyRevenue) {
  const base = REVENUE_MIDPOINT[monthlyRevenue];
  if (!base) return null;
  const low = Math.round(base * 1.8);
  const high = Math.round(base * 2.5);
  const avg = (low + high) / 2;
  const netProfit = Math.round(avg / 3);
  // 每個月其實少賺的區間（合作後潛力 - 目前）
  const lossLow = low - base;
  const lossHigh = high - base;
  return { current: base, low, high, netProfit, lossLow, lossHigh };
}

// ==============================================
// localStorage Mock 儲存（前端展示用，後端上線後移除）
// ==============================================
const SKEY = "lakeze_surveys";
const AKEY = "lakeze_ads";

export function saveSurvey(form) {
  const { status, rejectionReasons } = screenSurvey(form);
  const record = {
    id: Date.now(),
    ...form,
    status,
    rejectionReasons: rejectionReasons.join("；"),
    createdAt: new Date().toISOString(),
  };
  const all = getSurveys();
  all.unshift(record);
  localStorage.setItem(SKEY, JSON.stringify(all));
  return record;
}

export function getSurveys() {
  try {
    return JSON.parse(localStorage.getItem(SKEY) || "[]");
  } catch {
    return [];
  }
}

export function deleteSurvey(id) {
  localStorage.setItem(SKEY, JSON.stringify(getSurveys().filter((s) => s.id !== id)));
}

export function getAds() {
  try {
    const raw = localStorage.getItem(AKEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  const seed = [
    { id: 1, name: "宜蘭包棟-FB導流", spend: 45000, impressions: 320000, clicks: 8600, conversions: 210 },
    { id: 2, name: "露營主題-IG Reels", spend: 32000, impressions: 210000, clicks: 5400, conversions: 138 },
  ];
  localStorage.setItem(AKEY, JSON.stringify(seed));
  return seed;
}

export function saveAd(ad) {
  const all = getAds();
  if (ad.id) {
    const idx = all.findIndex((a) => a.id === ad.id);
    if (idx >= 0) all[idx] = ad;
  } else {
    all.unshift({ ...ad, id: Date.now() });
  }
  localStorage.setItem(AKEY, JSON.stringify(all));
  return all;
}

export function deleteAd(id) {
  localStorage.setItem(AKEY, JSON.stringify(getAds().filter((a) => a.id !== id)));
}
